import { useTimeRemainingMs } from 'components/mfa/hooks/use-time-remaining-ms.hook';

const MILLISECONDS_PER_SECOND = 1000;

export const useResendCountdown = (cooldownEndsAtMs: number | null): number => {
  const remainingMs = useTimeRemainingMs(cooldownEndsAtMs);
  if (remainingMs <= 0) {
    return 0;
  }
  return Math.ceil(remainingMs / MILLISECONDS_PER_SECOND);
};
